import { Theme } from '../types';

/**
 * Theme utility functions
 */

export const getInitialTheme = (): Theme => {
    if (typeof window !== 'undefined') {
        const storedTheme = localStorage.getItem('theme');
        if (storedTheme === 'light' || storedTheme === 'dark') {
            return storedTheme;
        }
    }
    return 'light';
};

export const applyTheme = (theme: Theme): void => {
    if (theme === 'dark') {
        document.documentElement.classList.add('dark');
    } else {
        document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
};

export const toggleTheme = (currentTheme: Theme): Theme => {
    return currentTheme === 'light' ? 'dark' : 'light';
};
